import styles from './Home.module.scss';
import { RouteComponentProps } from 'react-router-dom';
import HomepageExploration from '../../common/components/Homepage/HomepageExploration';
import HomepageContent from '../../common/components/Homepage/HomepageContent'

export const Home = (props: RouteComponentProps) => {
  return (
    <div className={['container-fluid', 'app', styles.app].join(' ')}>
      <HomepageExploration />
      <HomepageContent />
    </div>
  );
};

export default Home;
